class UserEdit {
  constructor(data = {}) {
    this.usuarioId = data.usuarioId || "";
    this.nombre = data.nombre || "";
    this.apellidoPaterno = data.apellidoPaterno || "";
    this.apellidoMaterno = data.apellidoMaterno || "";
    this.email = data.email || "";
    this.nombreUsuario = data.nombreUsuario || "";
    this.idLanguaje = data.idLanguaje || 1;
    this.password = data.password || "";
    this.foto = data.foto || "";
    this.repetirPassword = data.repetirPassword || "";
    this.rolesIds = data.rolesIds || "";
    this.checkBoxApp = data.checkBoxApp || false;
    this.empleado = data.empleado ? data.empleado : null;
    this.base64 = data.base64 || "";
    this.extension = data.extension || "";
    this.usuarioClientes = data.usuarioClientes|| null;
    this.idEmpresa = data.idEmpresa|| null;
  }
}

class UserAdd {
  constructor(data = {}) {
    this.usuarioId = data.usuarioId || "";
    this.nombre = data.nombre || "";
    this.apellidoPaterno = data.apellidoPaterno || "";
    this.apellidoMaterno = data.apellidoMaterno || "";
    this.email = data.email || "";
    this.nombreUsuario = data.nombreUsuario || "";
    this.idLanguaje = data.idLanguaje || 1;
    this.password = data.password || "";
    this.foto = data.foto || "";
    this.repetirPassword = data.repetirPassword || "";
    this.rolesIds = data.rolesIds || "";
    this.checkBoxApp = data.checkBoxApp || false;
    this.empleado = data.empleado ? data.empleado : null;
    this.base64 = data.base64 || "";
    this.extension = data.extension || "";
    this.usuarioClientes = data.usuarioClientes|| null;
    this.idEmpresa = data.idEmpresa|| null;
  }
}

export { UserEdit, UserAdd };
